import { routes as patient } from './patient'
import { routes as professional } from './professional'

export default [
  ...patient,
  ...professional
]



// WEBPACK FOOTER //
// ./src/app/routes.js